import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import Fonts from '../../fonts/';
import { AnimationComponent } from '../../Animations';

import styles from './basicText.module.scss';
import LinesEllipsis from 'react-lines-ellipsis';

const BasicTextWidgetComponent = ({className, style, widgetProps, breakpoint}) => {
  const elementRef = React.useRef(null);

  const id = _.get(widgetProps, 'uid');
  const content = _.get(widgetProps, 'content') || "";
  const animation = _.get(widgetProps, `properties.${breakpoint}.animation`) || {};
  const lines = getLinesToRender(widgetProps, breakpoint);

  Fonts.useFont(_.get(widgetProps, 'fonts') || []);
  
  var widgetStyle = {
    ...getStyles(widgetProps, breakpoint)
  }

  const removeHtmlTags = (htmlString) => {
    if(!htmlString) {
      return '';
    }
    
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return _.get(doc, 'body.textContent', '');
  };

  return (
    <div id={id}
      ref={elementRef}
      className={cx(className, styles.basicText, 'cs_basic_text_widget')}
      style={style}
      data-widget-id={id}
    >
      <AnimationComponent {...animation}>
        <LinesEllipsis 
          maxLine={lines} 
          text={removeHtmlTags(content)}
          className={styles.inner} 
          style={widgetStyle}
        ></LinesEllipsis>
      </AnimationComponent>
    </div>
  );
};

const getLinesToRender = (widgetProps, breakpoint) => {
  const lineHeight = _.get(widgetProps, `properties.${breakpoint}.lineSpacing`, 1.2);
  const fontSize = _.get(widgetProps, `properties.${breakpoint}.fontSize`, 16);


  var height = _.get(widgetProps, `properties.${breakpoint}.layout.height`);
  height = parseInt(height);
  
  const textHeight = lineHeight * fontSize;
  height = Math.max(height, textHeight);

  const lines = Math.floor(height / textHeight);
  return lines;
}

/**
 * Generate Styles
 * 
*/
function getStyles(widget, breakpoint) {
  var styles = {};

  const defaultProperties = _.get(widget, `properties.desktop`);
  const properties = _.get(widget, `properties.${breakpoint}`);

  if (!properties) {
    return styles;
  }

  //Layout
  const width = _.get(properties, 'layout.width');
  const height = _.get(properties, 'layout.height');
  styles = {
    ...styles,
    width: width,
    height: height
  }

  //font-color
  const colorRgb = _.get(defaultProperties, `font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  const defaultFont = _.get(defaultProperties, 'font', {});
  const font = _.get(properties, 'font', {});

  //font-family
  const fontFamily = _.get(defaultFont, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //font-size
  const fontSizeString = _.get(font, 'fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //line spacing
  const lineSpacingString = _.get(font, 'lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = _.get(font, 'letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-style
  const bold = _.get(defaultFont, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(defaultFont, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(defaultFont, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //alignment
  const alignment = _.get(properties, 'alignment', 'left');
  styles['textAlign'] = alignment;

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  var styles = {
    color: color
  };

  return styles;
}


const textWidgetEquals = function(prevProps, nextProps){
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const BasicTextWidget = React.memo(BasicTextWidgetComponent, textWidgetEquals);